import dayjs from 'dayjs';

export const HR_DEFAULT_PANE_LAYOUT = {
    filterPx: 280,
    detailPx: 420
};

export const HR_FILTER_FIELD_OPTIONS = [
    { value: 'fio', label: 'ФИО кандидата' },
    { value: 'stage_id', label: 'Стадия' },
    { value: 'assigned_by_id', label: 'Ответственный' },
    { value: 'vacancy', label: 'Вакансия' },
    { value: 'period', label: 'Период' },
    { value: 'source_id', label: 'Источник' },
    { value: 'phone', label: 'Телефон' },
    { value: 'has_call', label: 'Есть звонок' },
    { value: 'hide_closed', label: 'Скрыть «Выход»' }
];

export const HR_DEFAULT_FILTER_FIELDS =
    HR_FILTER_FIELD_OPTIONS.map(item => item.value);

export const clampHrPane = (value, min, max) =>
    Math.max(min, Math.min(max, Number(value) || min));

export const getCurrentMonthRange = () => [
    dayjs().startOf('month'),
    dayjs().endOf('month')
];

export const serializeHrFilters = ({
    fio = '',
    phone = '',
    stageId,
    assignedById,
    sourceId,
    vacancy,
    dateType = 'created',
    dateRange,
    hasCallOnly = false,
    hideClosed = true,
    search = ''
}) => ({
    search: String(search || '').trim() || '',
    fio: String(fio || '').trim() || '',
    phone: String(phone || '').replace(/\D+/g, '') || '',
    stage_id: stageId || null,
    assigned_by_id: assignedById || null,
    source_id: sourceId || null,
    vacancy: vacancy ? String(vacancy).trim() : '',
    date_type: dateType || 'created',
    date_from: dateRange?.[0]
        ? dateRange[0].format('YYYY-MM-DD')
        : null,
    date_to: dateRange?.[1]
        ? dateRange[1].format('YYYY-MM-DD')
        : null,
    has_call: Boolean(hasCallOnly),
    hide_closed: hideClosed !== false
});

export const parseHrDateRange = filters => {
    const from = filters?.date_from
        ? dayjs(filters.date_from)
        : null;
    const to = filters?.date_to
        ? dayjs(filters.date_to)
        : null;
    if (from?.isValid() && to?.isValid()) {
        return [from.startOf('day'), to.endOf('day')];
    }
    return getCurrentMonthRange();
};
